// extracted by mini-css-extract-plugin
export default {"close-button":"close-button-BcOSV","circle-close-button":"circle-close-button-OtgwS","dialog":"dialog-fk4vE"};